import React from "react";
export const UploadIcon = ({ color = "#000000" }) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M8.00016 3.00033L8.00016 9.66699M8.00016 3.00033C7.53334 3.00033 6.66118 4.32986 6.3335 4.667M8.00016 3.00033C8.46698 3.00033 9.33914 4.32986 9.66683 4.667"
			stroke="#1782FF"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M13.3334 11C13.3334 12.6547 12.9881 13 11.3334 13H4.66675C3.01208 13 2.66675 12.6547 2.66675 11"
			stroke="#1782FF"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
